// ---------------------------------------------------------------------------
// Parts & accessories catalogue.
//
// Source: Rango E Cycles' own IndiaMART listing
// https://www.indiamart.com/rango-e-cycles/products-and-services.html
// Prices and specifications as published there. Update when IndiaMART changes.
//
// `image` points at the IndiaMART CDN (5.imimg.com) — the same images already
// used on your own listing. If those ever stop loading, the card falls back to
// /accessories.jpg automatically (see FALLBACK_IMAGE below).
// ---------------------------------------------------------------------------

export const FALLBACK_IMAGE = "/accessories.jpg";

export const PART_CATEGORIES = [
  "Headlight",
  "Pump",
  "Lock",
  "Helmet",
  "Accessory",
  "Mobile Holder",
];

const IM = "https://5.imimg.com/data5/SELLER/Default/2025/3";

export const Parts = [
  // ---------------------------------------------------------------- Headlights
  {
    id: 1,
    Category: "Headlight",
    Brand: "EMotorad BlazeBeam Bicycle Headlight",
    Price: 1299,
    image: `${IM}/498570165/OZ/YN/AC/164019748/blazebeam-bicycle-headlight-250x250.jpg`,
    Features: "USB rechargeable LED headlight with a cold white beam",
    Suitablility: "Night riding and low-light commutes",
    Specs: [
      ["Lighting colour", "Cold White"],
      ["Battery type", "USB Rechargeable"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 2,
    Category: "Headlight",
    Brand: "EMotorad FireFly Bicycle Headlight",
    Price: 849,
    image: `${IM}/498570626/VI/RG/VW/164019748/firefly-bicycle-head-light-250x250.jpg`,
    Features: "Compact USB rechargeable headlight with a warm beam",
    Suitablility: "Everyday city commuting",
    Specs: [
      ["Lighting colour", "Warm Light"],
      ["Battery type", "USB Rechargeable"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 3,
    Category: "Headlight",
    Brand: "EMotorad Nexus Bicycle Headlight",
    Price: 1499,
    image: `${IM}/498571031/LC/UI/AE/164019748/nexus-bicycle-head-light-250x250.jpg`,
    Features: "Top-of-range warm-beam headlight, USB rechargeable",
    Suitablility: "Long-distance and highway riding",
    Specs: [
      ["Lighting colour", "Warm Light"],
      ["Battery type", "USB Rechargeable"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 4,
    Category: "Headlight",
    Brand: "EMotorad RadLite Bicycle Headlight",
    Price: 949,
    image: `${IM}/498571471/WQ/SU/YM/164019748/radlite-250x250.jpg`,
    Features: "Warm-beam USB rechargeable headlight",
    Suitablility: "Daily commuting",
    Specs: [
      ["Lighting colour", "Warm Light"],
      ["Battery type", "USB Rechargeable"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 5,
    Category: "Headlight",
    Brand: "EMotorad Lumo Bicycle Headlight",
    Price: 849,
    image: `${IM}/498572111/NJ/XO/ET/164019748/lumo-bicycle-headlight-250x250.jpg`,
    Features: "Cold white LED headlight, USB rechargeable",
    Suitablility: "City riding and school runs",
    Specs: [
      ["Lighting colour", "Cold White"],
      ["Battery type", "USB Rechargeable"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 6,
    Category: "Headlight",
    Brand: "EMotorad FlashTrail Bicycle Headlight",
    Price: 849,
    image: `${IM}/498575239/XS/EC/TX/164019748/flashtrail-bicycle-headlight-250x250.jpg`,
    Features: "Warm-beam USB rechargeable trail headlight",
    Suitablility: "Trail and off-road riding",
    Specs: [
      ["Lighting colour", "Warm Light"],
      ["Battery type", "USB Rechargeable"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 7,
    Category: "Headlight",
    Brand: "EMotorad Raylight Bicycle Headlight",
    Price: 799,
    image: `${IM}/498569368/EV/HN/RT/164019748/raylight-bicycle-head-light-250x250.png`,
    Features: "Lightweight plastic-bodied warm-beam headlight",
    Suitablility: "Budget pick for short evening rides",
    Specs: [
      ["Lighting colour", "Warm Light"],
      ["Material", "Plastic"],
      ["Brand", "EMotorad"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 8,
    Category: "Headlight",
    Brand: "EMotorad Beam Light Bicycle Headlight",
    Price: 899,
    image: `${IM}/498575964/ZC/VR/VI/164019748/beam-light-bicycle-headlight-250x250.png`,
    Features: "Black USB rechargeable headlight with a warm beam",
    Suitablility: "Everyday commuting",
    Specs: [
      ["Lighting colour", "Warm Light"],
      ["Battery type", "USB Rechargeable"],
      ["Colour", "Black"],
      ["Origin", "OEM"],
    ],
  },
  {
    id: 9,
    Category: "Headlight",
    Brand: "EMotorad Photon Bicycle Headlight",
    Price: 1199,
    image: `${IM}/498569693/SG/YZ/WQ/164019748/photon-bicycle-head-light-250x250.png`,
    Features: "Battery-powered LED headlight with front rack mount",
    Suitablility: "Riders using a front carrier or rack",
    Specs: [
      ["Headlight type", "LED"],
      ["Power source", "Battery"],
      ["Mount type", "Front Rack"],
      ["Origin", "OEM"],
    ],
  },

  // --------------------------------------------------------------------- Pumps
  {
    id: 10,
    Category: "Pump",
    Brand: "EMotorad Airwave Bicycle Pump",
    Price: 1599,
    image: `${IM}/498504916/KN/LB/DR/164019748/airwave-250x250.jpg`,
    Features: "Mild steel foot pump, the largest in the range",
    Suitablility: "Home workshop use and full-size tyres",
    Specs: [
      ["Type", "Foot Pump"],
      ["Material", "Mild Steel"],
      ["Colour", "White"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 11,
    Category: "Pump",
    Brand: "EMotorad MiniAirJet Hand Air Pump",
    Price: 849,
    image: `${IM}/498505485/VO/TM/ZR/164019748/mini-air-jet-250x250.jpg`,
    Features: "Compact mild steel hand pump that mounts to the frame",
    Suitablility: "Carrying on the ride for roadside top-ups",
    Specs: [
      ["Model", "MiniAirJet"],
      ["Material", "Mild Steel"],
      ["Colour", "Black"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 12,
    Category: "Pump",
    Brand: "EMotorad MiniAir Bicycle Foot Pump",
    Price: 649,
    image: `${IM}/498505992/QQ/OQ/PS/164019748/mini-air-250x250.png`,
    Features: "Entry-level mild steel foot pump",
    Suitablility: "Occasional home use",
    Specs: [
      ["Model", "MiniAir"],
      ["Material", "Mild Steel"],
      ["Colour", "Black"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 13,
    Category: "Pump",
    Brand: "EMotorad AirPlus Bicycle Foot Pump",
    Price: 999,
    image: `${IM}/499233201/TH/NP/HB/164019748/airplus-bicycle-air-pump-250x250.png`,
    Features: "Mild steel foot pump with a larger barrel",
    Suitablility: "Regular home use",
    Specs: [
      ["Type", "Foot Pump"],
      ["Model", "AirPlus"],
      ["Material", "Mild Steel"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 14,
    Category: "Pump",
    Brand: "EMotorad AirFlow Bicycle Air Pump",
    Price: 1049,
    image: `${IM}/498504291/JF/YY/PM/164019748/air-flow-bicycle-air-pump-250x250.jpg`,
    Features: "Mild steel foot pump in orange",
    Suitablility: "Regular home and workshop use",
    Specs: [
      ["Type", "Foot Pump"],
      ["Material", "Mild Steel"],
      ["Colour", "Orange"],
      ["Brand", "EMotorad"],
    ],
  },

  // --------------------------------------------------------------------- Locks
  {
    id: 15,
    Category: "Lock",
    Brand: "EMotorad FortKnox Lite Bicycle Lock",
    Price: 379,
    image: `${IM}/498555327/II/RY/BH/164019748/fortknox-lite-bicycle-lock-250x250.jpg`,
    Features: "Combination cable lock supplied with 4 keys",
    Suitablility: "Short stops and low-risk parking",
    Specs: [
      ["Lock feature", "Combination Lock"],
      ["Lock type", "Cable Lock"],
      ["Number of keys", "4"],
      ["Colour", "Black"],
    ],
  },
  {
    id: 16,
    Category: "Lock",
    Brand: "EMotorad KeyGuard Bicycle Lock",
    Price: 379,
    image: `${IM}/498567153/AX/ME/ZN/164019748/keyguard-bicycle-lock-250x250.jpg`,
    Features: "Side key cable lock",
    Suitablility: "Riders who prefer a key over a combination",
    Specs: [
      ["Lock feature", "Side Key Lock"],
      ["Lock type", "Cable Lock"],
      ["Colour", "Black"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 17,
    Category: "Lock",
    Brand: "EMotorad FortKnox Pro Bicycle Lock",
    Price: 849,
    image: `${IM}/498568351/QQ/ID/HU/164019748/fortknox-pro-bicycle-lock-250x250.png`,
    Features: "Heaviest-duty combination cable lock in the range",
    Suitablility: "Longer stops and street parking",
    Specs: [
      ["Lock feature", "Combination Lock"],
      ["Lock type", "Cable Lock"],
      ["Usage", "Bicycle"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 18,
    Category: "Lock",
    Brand: "EMotorad FortKnox Plus Bicycle Lock",
    Price: 549,
    image: `${IM}/498567821/MZ/IZ/DE/164019748/fortknox-plus-250x250.jpg`,
    Features: "Mid-range combination cable lock with 4 keys",
    Suitablility: "Daily commuting and office parking",
    Specs: [
      ["Lock feature", "Combination Lock"],
      ["Lock type", "Cable Lock"],
      ["Number of keys", "4"],
      ["Colour", "Black"],
    ],
  },

  // ------------------------------------------------------------------ Helmets
  {
    id: 19,
    Category: "Helmet",
    Brand: "EMotorad Beacon Bicycle Helmet",
    Price: 2999,
    image: `${IM}/498500373/LT/XB/TU/164019748/beacon-250x250.jpg`,
    Features: "EPS helmet, medium size, 330 g",
    Suitablility: "Premium pick for regular riders",
    Specs: [
      ["Material", "EPS"],
      ["Size", "Medium"],
      ["Weight", "330 g"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 20,
    Category: "Helmet",
    Brand: "EMotorad AeroShield Bicycle Helmet",
    Price: 1799,
    image: `${IM}/498500975/IB/RS/NR/164019748/aeroshield-250x250.jpg`,
    Features: "EPS helmet in black, medium size",
    Suitablility: "Everyday commuting",
    Specs: [
      ["Material", "EPS"],
      ["Size", "Medium"],
      ["Colour", "Black"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 21,
    Category: "Helmet",
    Brand: "EMotorad Slipstream Bicycle Helmet",
    Price: 1799,
    image: `${IM}/498501583/ML/VC/YL/164019748/slipstream-250x250.png`,
    Features: "EPS road helmet, medium size, customisable fit",
    Suitablility: "Road riding and fitness rides",
    Specs: [
      ["Helmet type", "Road Helmet"],
      ["Material", "EPS"],
      ["Size", "Medium"],
      ["Head size range", "Customisable"],
    ],
  },

  // -------------------------------------------------------------- Accessories
  {
    id: 22,
    Category: "Accessory",
    Brand: "EMotorad Plastic Bicycle Mudguard",
    Price: 399,
    image: `${IM}/498577850/CZ/GP/MF/164019748/plastic-fender-250x250.jpg`,
    Features: "Plastic mudguard for 27 inch tyres",
    Suitablility: "Folding bikes and monsoon riding",
    Specs: [
      ["Material", "Plastic"],
      ["Compatible tyre size", "27 inch"],
      ["Compatible bicycle", "Folding Bike"],
      ["Colour", "Black"],
    ],
  },
  {
    id: 23,
    Category: "Accessory",
    Brand: "Bicycle Metal Mudguard",
    Price: 799,
    image: `${IM}/498576985/FY/KK/KG/164019748/metal-fender-250x250.jpg`,
    Features: "Metal mudguard for X1, X2, Neo and Legend 07",
    Suitablility: "Monsoon riding on EMotorad models",
    Specs: [
      ["Material", "Metal"],
      ["Fits", "X1, X2, Neo, Legend 07"],
      ["Colour", "Black"],
      ["Brand", "EMotorad"],
    ],
  },
  {
    id: 24,
    Category: "Accessory",
    Brand: "Bicycle Front Basket",
    Price: 312,
    image: `${IM}/499067587/UM/EC/UQ/164019748/bicycles-front-basket-250x250.jpg`,
    Features: "Powder-coated front basket, 800 g capacity",
    Suitablility: "Shopping runs and school bags",
    Specs: [
      ["Basket type", "Front Basket"],
      ["Capacity", "800 g"],
      ["Surface finish", "Powder Coated"],
      ["For", "Unisex"],
    ],
  },
  {
    id: 25,
    Category: "Accessory",
    Brand: "Rear Side Hook",
    Price: 124,
    image: `${IM}/499074598/YR/XG/QW/164019748/rear-side-hook-250x250.jpg`,
    Features: "Rust-proof iron hook, 13 mm, 150 g",
    Suitablility: "Hanging bags from the rear carrier",
    Specs: [
      ["Material", "Iron"],
      ["Rust proof", "Yes"],
      ["Size", "13 mm"],
      ["Item weight", "150 g"],
    ],
  },

  // ------------------------------------------------------------ Mobile Holder
  {
    id: 26,
    Category: "Mobile Holder",
    Brand: "EMotorad Rivet 360 Mobile Holder",
    Price: 399,
    image: `${IM}/498579121/NQ/FB/YT/164019748/rivet-360-mobile-holder-250x250.png`,
    Features: "360° rotating handlebar phone mount",
    Suitablility: "Navigation and ride tracking",
    Specs: [["Brand", "EMotorad"], ["Rotation", "360°"], ["Mount", "Handlebar"]],
  },
];

export default Parts;
